import axios from "@/app/Axios";
class usuarios {
  async getUsuarios() {
    try {
      const response = await axios.get("/usuario");
      return response.data;
    } catch (error) {
      console.log(error);
      return { status: false, message: "Error interno del servidor" };
    }
  }
  //usuariorol
  async getUsuariosRol() {
    try {
      const response = await axios.get("/usuariorol");
      return response.data;
    } catch (error) {
      console.log(error);
      return { status: false, message: "Error interno del servidor" };
    }
  }
  //usuariorolactividad
  async getUsuariosActividad() {
    try {
      const response = await axios.get("/usuariorolactividad");
      return response.data;
    } catch (error) {
      console.log(error);
      return { status: false, message: "Error interno del servidor" };
    }
  }
  //usuariorolevaluacion
  async getUsuariosEvaluacion() {
    try {
      const response = await axios.get("/usuariorolevaluacion");
      return response.data;
    } catch (error) {
      console.log(error);
      return { status: false, message: "Error interno del servidor" };
    }
  }
  async saveUsuarios(data) {
    try {
        console.log("Respuesta de Servicio ",data);
      const response = await axios.post("/register", data);
      console.log("Respuesta de Servicio ",response);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }
  async cambiarPassword(data) {
    try {
        console.log("Respuesta de Servicio ",data);
      const response = await axios.post("/change-password", data);
      console.log("Respuesta de Servicio ",response);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }
  async updateUsuarios(id, data) {
    try {
        const response = await axios.put(`/usuarioupdate/${id}`, data);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            return error.response.data;
        } else {
            console.log(error);
        }
    }
}
async buscarcarnet(id) {
  try {
      const response = await axios.get(`/usuariocarnet/${id}`);
      return response.data;
  } catch (error) {
      if (error.response && error.response.status === 401) {
          return error.response.data;
      } else {
          console.log(error);
      }
  }
}
async getDatosUserLogued() {
  try {
    const response = await axios.get("/mostrar_datos_user");
    console.log("Respuesta de Servicio actividades", response);
    return response.data;
  } catch (error) {
    console.log(error);
    return { status: false, message: "Error interno del servidor" };
  }
}
async updateUsuariosFirstPass(id, data) {
  try {
      const response = await axios.put(`/usuarioupdatefirstpass/${id}`, data);
      return response.data;
  } catch (error) {
      if (error.response && error.response.status === 401) {
          return error.response.data;
      } else {
          console.log(error);
      }
  }
}

async validateCurrentPassword(currentPassword) {
  try {
      const response = await axios.post('/validate-current-password', { password: currentPassword });
      return response.data.valid;
  } catch (error) {
      console.error('Error al validar la contraseña actual:', error);
      return false;
  }
}
  async destroyusuarios(id) {
    try {
      const response = await axios.delete(`/usuariodelete/${id}`);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        return error.response.data;
      } else {
        console.log(error);
      }
    }
  }
}
export default usuarios;
